import { render, staticRenderFns } from "./activityPeopleList.vue?vue&type=template&id=48715870&scoped=true&"
import script from "./activityPeopleList.vue?vue&type=script&lang=js&"
export * from "./activityPeopleList.vue?vue&type=script&lang=js&"
import style0 from "./activityPeopleList.vue?vue&type=style&index=0&id=48715870&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48715870",
  null
  
)

export default component.exports